import { render, staticRenderFns } from "./orderEvaluate.vue?vue&type=template&id=6b85465e&scoped=true"
import script from "./orderEvaluate.vue?vue&type=script&lang=js"
export * from "./orderEvaluate.vue?vue&type=script&lang=js"
import style0 from "./orderEvaluate.vue?vue&type=style&index=0&id=6b85465e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85465e",
  null
  
)

export default component.exports